import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addDelivery,
  deleteDelivery,
  fetchDeliveryList,
  fetchDeliveryVendorApi,
  moveDelivery,
  updateDelivery,
} from "../../apis/delivery";

import type { DeliveryUpdatePayload } from "../../utils/types/delivery";

export const fetchDeliveryListData = createAsyncThunk(
  "delivery/fetchDeliveryList",
  async (
    { berthId, job_id }: { berthId?: string; job_id?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchDeliveryList(berthId, job_id);
      return {
        data: response,
        jobId: job_id,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateDeliveryData = createAsyncThunk(
  "delivery/updateDelivery",
  async (
    {
      id,
      berthId,
      jobId,
      data,
    }: {
      id: string;
      jobId?: string;
      berthId: string;
      data: { [key: string]: any; deliveryVendorId: string };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateDelivery(id, berthId || undefined, jobId, data);
      return { success: true, data, berthId, jobId, deliveryVendorId: id };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDeliveryData = createAsyncThunk(
  "delivery/deleteDelivery",
  async (
    { id, berthId, jobId }: { id: string; berthId: string; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteDelivery({ id, berthId });
      if (response.success) {
        return { deliveryVendorId: id, jobId, success: true };
      }
      return rejectWithValue("Unknown error… Please try again");
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchDeliveryVendor = createAsyncThunk(
  "deliveryVendor/fetchDeliveryVendor",
  async (
    { deliveryVendorId }: { deliveryVendorId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchDeliveryVendorApi({ deliveryVendorId });
      return response;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addDeliveryData = createAsyncThunk(
  "delivery/addDelivery",
  async ({ data }: { data: DeliveryUpdatePayload }, { rejectWithValue }) => {
    try {
      const response = await addDelivery(data);
      return {
        data: response,
        jobId: data.job_id,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const moveDeliveryData = createAsyncThunk(
  "delivery/moveDelivery",
  async (
    {
      id,
      berthId,
      jobId,
    }: {
      id: string;
      berthId: string;
      jobId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await moveDelivery(id, berthId);
      return {
        success: true,
        deliveryVendorId:id,
        data: {
          deliveryVendorId: id,
          berthId,
        },
        jobId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
